export default __webpack_public_path__ + "static/firebase-240e15b35dce1932a497fcb2841fabb4.png";